module Shared.Admin.ManageNews.Grid

open System

type SortField =
    | Headline
    | StartShowing
    | StopShowing
    | Published

type SortDirection =
    | Asc
    | Desc

module SortDirection =
    let toggle =
        function
        | Asc -> Desc
        | Desc -> Asc

type SortInfo =
    {
        Field: SortField
        Direction: SortDirection
    }

type NewsArticleDTO = 
    {
        Id: Guid
        Headline: string  
        StartShowing: DateTime
        StopShowing: DateTime option
        Published: bool
    }
